/**
 * Feature flags for items not yet ready for launch.
 * Set to true to show the feature in nav / Administration / user dropdown.
 * Routes and components stay in place; only visibility is toggled here.
 */
export const FEATURES = {
    fullPageBuilder: true,
    analytics: false,
    dateAndTime: false,
    websiteBuilder: false,
    activityLog: false,
} as const

export type FeatureKey = keyof typeof FEATURES
